import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {PriceLevelSearchModel} from "../price-level-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {PriceLevelSearchPageComponent} from "../price-level-search-page/price-level-search-page.component";
import {PriceLevelEditPageComponent} from "../price-level-edit-page/price-level-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-price-level-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        provideSearchModel(PriceLevelSearchModel),
        registerSelectEditControl(PriceLevelSingleSelectEditControlComponent)
    ]
})
export class PriceLevelSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PriceLevelSearchModel> {
    @Input() includeActivePriceLevel: boolean;
    @Input() activePriceLevelLabel: string;

    constructor(model: PriceLevelSearchModel, injector: Injector) {
        super(model, injector, "priceLevelId", "name", true);

        this.extendedSearchComponent = PriceLevelSearchPageComponent;
        this.extendedEditComponent = PriceLevelEditPageComponent;
    }

    @Input() set excludePriceLevelId(excludePriceLevelId: number) {
        this.model.setFilterValue(PriceLevelSearchModel.EXCLUDE_PRICE_LEVEL_ID_FILTER_NAME, excludePriceLevelId);
    }

    override onDataLoaded(data: Array<any>): void {
        if (this.includeActivePriceLevel) {
            data.unshift({
                [this.labelField]: this.translateService.instant(this.activePriceLevelLabel),
                [this.valueField]: PriceLevelSearchModel.ACTIVE_PRICE_LEVEL
            });
        }
    }

    override onOptionOpen(option: any): void {
        if (option[this.valueField] !== PriceLevelSearchModel.ACTIVE_PRICE_LEVEL) {
            this.selectControlComponent.openView(option);
        }
    }
}
